import { useApolloClient } from "@apollo/client";
import { useState } from "react";
import DatePicker from "react-date-picker";

import IconCheck from "../../images/icon_check.svg";
import LoadingIcon from "../../images/icon_loading_green.gif";
import { FILE_FORMATS } from "../../utils/constants";
import AdminComplaintFileUpload from "../AdminComplaintFileUpload/AdminComplaintFileUpload";
import Input from "../Input/Input";
import Select from "../Select/Select";
import {
  AuxContainer,
  BigTitle,
  Box,
  Container,
  GreenButton,
  GridContainer,
  LargeContainer,
  SubTitle,
} from "./AdminComplaintsDetailResultStyles";
import { requestDataResult } from "./requestData";
import uploadFileToS3 from "./UploadToS3";

export default function AdminComplaintsDetailResult(props) {
  const client = useApolloClient();
  const { result, onResultChange, complaintId, refreshPage } = props;
  const [fileToUpload, updateFileFileToUpload] = useState([]);
  const [waitingForServerResponse, updateWaitingForServerResponse] =
    useState(false);
  const onClick = () => {
    if (waitingForServerResponse) return;
    updateWaitingForServerResponse(true);
    uploadFileToS3("complaints", fileToUpload, "quejas-reclamos")
      .then((urlFiles) => {
        requestDataResult(client, result, complaintId, urlFiles)
          .then(() => {
            refreshPage();
            updateWaitingForServerResponse(false);
          })
          .catch(() => updateWaitingForServerResponse(false));
      })
      .catch(() => updateWaitingForServerResponse(false));
  };

  return (
    <Container>
      <div>
        <BigTitle>Respuesta</BigTitle>
        <GridContainer>
          <Box>
            <SubTitle> Fecha de aprobación: </SubTitle>
            <DatePicker
              value={result.approvalDate}
              onChange={(newDate) => onResultChange({ approvalDate: newDate })}
              clearIcon={null}
              dayPlaceholder={"dd"}
              locale={"es-PE"}
              monthPlaceholder={"mm"}
              showLeadingZeros={true}
              yearPlaceholder={"aaaa"}
            />
          </Box>
          <Box>
            <SubTitle> Días de atención: </SubTitle>
            <Input
              width="25.6rem"
              height="5rem"
              value={result.businessDays}
              onChange={(ev) =>
                onResultChange({ businessDays: ev.target.value })
              }
              placeholder="Número de días"
              type="number"
            />
          </Box>
          <Box>
            <SubTitle> Medio de respuesta: </SubTitle>
            <Select
              height="5rem"
              width="25.6rem"
              value={result.responseMedium}
              onChange={(ev) =>
                onResultChange({ responseMedium: ev.target.value })
              }
            >
              <option disabled value="">
                (Seleccione un medio)
              </option>
              <option value="presencial">Presencial</option>
              <option value="virtual">Virtual</option>
              <option value="correo">Correo</option>
              <option value="llamada">LLamada</option>
              <option value="otros">Otros</option>
            </Select>{" "}
            {/* TODO: add more options */}
          </Box>
          <Box>
            <SubTitle> Observación: </SubTitle>
            <Input
              width="25.6rem"
              height="5rem"
              value={result.observation}
              onChange={(ev) =>
                onResultChange({ observation: ev.target.value })
              }
              placeholder="Nro. de procesos"
            />
          </Box>
          <Box>
            <SubTitle> Días de respuesta: </SubTitle>
            <Input
              width="25.6rem"
              height="5rem"
              value={result.responseDays}
              onChange={(ev) =>
                onResultChange({ responseDays: ev.target.value })
              }
              placeholder="Número de días"
              type="number"
            />
          </Box>
          <Box>
            <SubTitle> Pendiente por: </SubTitle>
            <Input
              width="25.6rem"
              height="5rem"
              value={result.pending}
              onChange={(ev) => onResultChange({ pending: ev.target.value })}
              placeholder="Número de días"
              type="number"
            />
          </Box>
        </GridContainer>
      </div>
      <div>
        <BigTitle>Pagos</BigTitle>
        <GridContainer>
          <Box>
            <SubTitle> Indemnización: </SubTitle>
            <Input
              width="25.6rem"
              height="5rem"
              value={result.compensation}
              onChange={(ev) =>
                onResultChange({ compensation: ev.target.value })
              }
              placeholder="Monto (USD)"
              type="number"
            />
          </Box>
          <Box>
            <SubTitle> Indemnización de trámite: </SubTitle>
            <Input
              width="25.6rem"
              height="5rem"
              value={result.compensationProcess}
              onChange={(ev) =>
                onResultChange({ compensationProcess: ev.target.value })
              }
              placeholder="Monto (USD)"
              type="number"
            />
          </Box>
          <Box>
            <SubTitle> Responsable de pago: </SubTitle>
            <Input
              width="25.6rem"
              height="5rem"
              value={result.responsibleForPayment}
              onChange={(ev) =>
                onResultChange({ responsibleForPayment: ev.target.value })
              }
              placeholder="Nombre del responsable"
            />
          </Box>
          <Box>
            <SubTitle> Fecha de pago: </SubTitle>
            <DatePicker
              value={result.paymentDate}
              onChange={(newDate) => onResultChange({ paymentDate: newDate })}
              clearIcon={null}
              dayPlaceholder={"dd"}
              locale={"es-PE"}
              monthPlaceholder={"mm"}
              showLeadingZeros={true}
              yearPlaceholder={"aaaa"}
            />
          </Box>
        </GridContainer>
      </div>
      <LargeContainer>
        <Box>
          <SubTitle>Indemnización</SubTitle>
          <div className="fix-margin">
            <AdminComplaintFileUpload
              maxFiles={1}
              onCurrentFileChange={(newFile) =>
                onResultChange({
                  compensationFile: newFile,
                })
              }
              currentFile={result.compensationFile}
              onValueChange={(newList) => updateFileFileToUpload(newList)}
              value={fileToUpload}
              formats={[FILE_FORMATS.IMAGE, FILE_FORMATS.PDF]}
            />
          </div>
        </Box>
        <Box>
          <SubTitle>Razón social</SubTitle>
          <Input
            width="52.2rem"
            height="5rem"
            value={result.socialReason}
            onChange={(ev) => onResultChange({ socialReason: ev.target.value })}
            placeholder="Nombre del responsable"
          />
        </Box>
      </LargeContainer>
      <div>
        <GridContainer>
          <Box>
            <SubTitle> Cuenta bancaria: </SubTitle>
            <Input
              width="25.6rem"
              height="5rem"
              value={result.bankAccount}
              onChange={(ev) =>
                onResultChange({ bankAccount: ev.target.value })
              }
              placeholder="Ej. 00102389182391982312"
            />
          </Box>
          <Box>
            <SubTitle> Banco: </SubTitle>
            <Input
              width="25.6rem"
              height="5rem"
              value={result.bank}
              onChange={(ev) => onResultChange({ bank: ev.target.value })}
              placeholder="Banco"
            />
          </Box>
          <Box>
            <SubTitle> Número de transacción: </SubTitle>
            <Input
              width="25.6rem"
              height="5rem"
              value={result.transactionDocument}
              onChange={(ev) =>
                onResultChange({ transactionDocument: ev.target.value })
              }
              placeholder="Documento de transacción"
            />
          </Box>
        </GridContainer>
      </div>
      <AuxContainer>
        <GreenButton onClick={onClick}>
          {!waitingForServerResponse ? (
            <img src={IconCheck} alt="check" />
          ) : (
            <img src={LoadingIcon} className="icon" alt="spinner" />
          )}
          <h2>Guardar datos del resultado</h2>
        </GreenButton>
      </AuxContainer>
    </Container>
  );
}
